module.exports = __webpack_public_path__ + "static/media/29DUNON4.ba900264.jpg";